import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';

type ShowParams = {
  license: string;
  trend: string;
  trend_period: number;
  state?: string;
  paging_params: {
    limit: number;
    page: number;
  };
  sort_params: {
    field: string;
    order: Order;
  };
};

export const show = async ({ license, ...params }: ShowParams) =>
  apiClient.get(`/company_trends/${license}`, { params });
